<template>
  <div>
    <div id="vue-wf-event-listing">
      <wf-event-listing :event-filter-options="eventFilterOptions">
        <template slot-scope="{ eventFilter }">
          <div v-for="event in eventsList" :key="event.event_Title">
            <wf-event-listing-item
              :event-type="event.Event_Type"
              :event-filter="eventFilter"
            >
              <div class="wf-event-listing-item">
                <div class="wf-event-listing-item-section">
                  <div class="wf-event-date-box">
                    <div class="wf-event-date-box-month">
                      {{ event.event_Date }} {{ event.event_Date.year }}
                    </div>
                    <div class="wf-event-date-box-day">
                      {{ event.event_Date.day }}
                    </div>
                  </div>
                </div>
                <div class="wf-event-listing-item-section">
                  <div class="wf-event-date-time">
                    {{ event.event_Date }} {{ event.event_Timings }}
                  </div>
                  <div class="secondary-heading">
                    {{ event.event_Type }}
                  </div>
                  <div class="h3 mb-0">
                    {{ event.event_Title }}
                  </div>

                  <a
                    class="call-to-action-button btn btn-white border-dark mt-3"
                    :href="event.NodeAlias"
                  >
                    View details
                    <span class="png-icon png-icon-icons-glyph--k-arrow-next ">
                    </span>
                  </a>
                </div>
              </div>
            </wf-event-listing-item>
          </div>
        </template>
      </wf-event-listing>
    </div>
    <div class="wf-get-in-touch wf-get-in-touch-reverse-colors">
      <div class="container-fluid">
        <div class="section-content">
          <div class="container-fluid">
            <div class="wf-get-in-touch-wrapper">
              <h2 class="h1">
                {{ data.title }}
              </h2>
              <p>
                {{ data.description }}
              </p>
              <a
                class="call-to-action-button btn btn-primary"
                :href="data.ctaLink"
              >
                {{ data.ctaText }}
                <span class="png-icon png-icon-icons-glyph--ko-arrow-next ">
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <wf-back-to-top-button />
  </div>
</template>

<script>
import WfEventListing from "../wf-event-listing.vue";
import WfEventListingItem from "../wf-event-listing-item.vue";
import WfBackToTopButton from "../wf-back-to-top-button.vue";
export default {
  props: { eventFilterOptions: Array, eventsList: Array, data: Object },
  components: {
    WfEventListing,
    WfEventListingItem,
    WfBackToTopButton
  }
};
</script>
